module.exports = __webpack_public_path__ + "static/images/enter-game-bg1.c6a9fd4.png";